import { createSelector } from 'reselect';

const stateProfileSelector = (state) => state.profile;

export const profileSelector = createSelector(
    [stateProfileSelector],
    (profile) => {
        return { ...profile };
    }
);